/**
 * Road-call bridge dialer shared constants.
 * Ported from Warpspeed's functions/bonita/road-voice.js `normalizeToE164`.
 */

// Must stay aligned with functions/roadVoice.js's normalizeToE164 — both
// sides derive the call-expectations doc id from the same phone number.
export function normalizeToE164(raw) {
  let s = String(raw || "").trim();
  const hasPlus = s.startsWith("+");
  s = s.replace(/\D/g, "");
  if (!s) return "";
  if (hasPlus) return `+${s}`;
  if (s.length === 11 && s.startsWith("1")) return `+${s}`;
  if (s.length === 10) return `+1${s}`;
  return "";
}

export const CALLBACK_WINDOW_MS = 30 * 60 * 1000;
